'use client'

import { InnocodeProviderWrapper } from '@intsoft/innocode-core'
import AdminLayout from '@/components/common/layout/AdminLayout'

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <InnocodeProviderWrapper>
      <AdminLayout>
        {children}
      </AdminLayout>
    </InnocodeProviderWrapper>
  )
}
